import { pathsManifest as authCheckPaths } from '@zg-rentals/particles-js-auth';

interface SignInPageInterface {
  pathname: string;
  search: string;
}

export default {
  signInPage: ({ pathname, search = '' }: SignInPageInterface) => authCheckPaths.zillow.signInPage(pathname, search),
  logOutPage: (): string => '/Logout.htm',
  brandHomePage: '/',
  rhwHomePage: '/renter-hub',
  baseUrl: '/renter-hub/payments',

  // Onboarding paths
  paymentInfoPage: '/payment-info',
  paymentSettingsPage: '/payment-settings',
  moveInCostsSchedulingPage: '/schedule-move-in-costs',
  paymentReportingOptInPage: '/payment-reporting-opt-in',
  rentReportingPage: '/rent-reporting',

  // Dashboard paths
  editPaymentInfoPage: '/edit/payment-info',
  editPaymentSettingsPage: '/edit/payment-settings',
  oneTimePaymentPage: '/pay-one-time-payment',
  cancelPaymentPage: '/cancel-payment',
  cancelMoveInCostsPage: '/cancel-move-in-payment',
  editMoveInCostsSchedulePage: '/edit/schedule-move-in-costs',
  payPastDueRentPaymentPage: '/pay-past-due-rent-payment',
  editPaymentReportingEnrollmentPage: '/edit/reporting-enrollment',
  managePaymentMethodsPage: '/edit/manage-payment-methods',
  updatePaymentMethodsPage: '/edit/update-payment-methods',
  plaidMicroDepositsPage: '/plaid-micro-deposits',

  // ZRM
  landlordPropertyPage: '/rental-manager/properties',
};
